export default {
  title: 'Détails du code promo',
  back: 'Retour aux codes promo',
  tabs: {
    customers: 'Clients',
    orders: 'Commandes',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Valeur moy. de commande',
    customer_adoption: 'Clients uniques',
  },
  toasts: {
    failed_to_load_stats: 'Échec du chargement des statistiques',
  },
};
